import { render } from "./MedicareAdvantage.vue?vue&type=template&id=6ae89d32"
import script from "./MedicareAdvantage.vue?vue&type=script&lang=js"
export * from "./MedicareAdvantage.vue?vue&type=script&lang=js"

import "./MedicareAdvantage.vue?vue&type=style&index=0&id=6ae89d32&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__